import { cn } from '@/lib/utils';

interface BrandMarkProps {
  className?: string;
  /** Icon size in pixels (width & height). Defaults to 24. */
  size?: number;
  alt?: string;
}

/** App logo mark — same asset as the favicon / PWA icon. */
export function BrandMark({ className, size = 24, alt = 'My Budget' }: BrandMarkProps) {
  return (
    <img
      src="/favicon.svg"
      width={size}
      height={size}
      alt={alt}
      className={cn('shrink-0', className)}
      draggable={false}
    />
  );
}
